import { useSafePush } from '../../hooks/useSafePush'
import Box, { BoxProps } from '@mui/material/Box'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { SortByFilterType } from '@/interfaces/filters'
import { getSortByFilterHref } from '@/helpers/filters'

interface SortByFilterProps extends BoxProps {
  sortByFilter: SortByFilterType
}

export const SortByFilter = ({ sortByFilter = 'project_popular', ...props }: SortByFilterProps): React.ReactElement => {
  const { asPath } = useRouter()
  const { safePush } = useSafePush()

  const { t } = useTranslation('subheader')

  const handleChange = (event: any): void => {
    const href = getSortByFilterHref(event.target.value, asPath)
    safePush(href)
  }

  return (
    <Box {...props}>
      <Select value={sortByFilter} onChange={handleChange} qa-attribute="sortByFilter" sx={{ height: '40px' }}>
        <MenuItem value="" disabled>
          {t('sortBy')}
        </MenuItem>
        <MenuItem value="project_popular">{t('sortByPopularity')}</MenuItem>
        <MenuItem value="project_views">{t('sortByNumberOfViews')}</MenuItem>
        <MenuItem value="project_copies">{t('sortByNumberOfCopies')}</MenuItem>
        <MenuItem value="project_creationdate">{t('sortByCreationDate')}</MenuItem>
        <MenuItem value="project_lastchange">{t('sortByModificationDate')}</MenuItem>
      </Select>
    </Box>
  )
}
